import { UNIFIED_DESTINATIONS } from "../unifiedSearchMockup/demoFixtures";

/** Common English / Hebrew country labels → ISO2 for Hubwayz destinations API. */
const COUNTRY_NAME_TO_ISO2 = Object.freeze({
  israel: "IL",
  ישראל: "IL",
  greece: "GR",
  יוון: "GR",
  "united arab emirates": "AE",
  uae: "AE",
  dubai: "AE",
  "איחוד האמירויות": "AE",
  דובאי: "AE",
  hungary: "HU",
  הונגריה: "HU",
  cyprus: "CY",
  קפריסין: "CY",
  "czech republic": "CZ",
  czechia: "CZ",
  צכיה: "CZ",
  "צ׳כיה": "CZ",
  italy: "IT",
  איטליה: "IT",
  spain: "ES",
  ספרד: "ES",
  france: "FR",
  צרפת: "FR",
  turkey: "TR",
  תורכיה: "TR",
  טורקיה: "TR",
  georgia: "GE",
  גאורגיה: "GE",
  thailand: "TH",
  תאילנד: "TH",
  "united states": "US",
  usa: "US",
  "united kingdom": "GB",
  uk: "GB",
  germany: "DE",
  גרמניה: "DE",
  austria: "AT",
  אוסטריה: "AT",
  netherlands: "NL",
  הולנד: "NL",
  portugal: "PT",
  פורטוגל: "PT",
  bulgaria: "BG",
  בולגריה: "BG",
  romania: "RO",
  רומניה: "RO",
  poland: "PL",
  פולין: "PL",
});

function norm(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

export function resolveCountryIso2FromSearchPhrase(searchPhrase = {}, location = null) {
  const direct =
    searchPhrase.countryCode ||
    searchPhrase.country_code ||
    searchPhrase.CountryCode ||
    location?.countryCode ||
    location?.COUNTRYCODE ||
    location?.iso2 ||
    location?.ISO2;
  if (direct && /^[A-Za-z]{2}$/.test(String(direct).trim())) {
    return String(direct).trim().toUpperCase();
  }

  // Google address_components short_name
  const comps = location?.address_components || searchPhrase.address_components;
  if (Array.isArray(comps)) {
    const countryComp = comps.find(
      (c) => Array.isArray(c?.types) && c.types.includes("country")
    );
    const short = countryComp?.short_name || countryComp?.shortName;
    if (short && /^[A-Za-z]{2}$/.test(String(short).trim())) {
      return String(short).trim().toUpperCase();
    }
  }

  const countryName = norm(searchPhrase.country || location?.country || location?.COUNTRYNAME);
  if (COUNTRY_NAME_TO_ISO2[countryName]) return COUNTRY_NAME_TO_ISO2[countryName];

  // UNIFIED_DESTINATIONS hints by city label
  const city = norm(searchPhrase.city || location?.city || location?.CITYNAME || searchPhrase.hotelName);
  for (const d of UNIFIED_DESTINATIONS) {
    if (norm(d.label) === city || norm(d.hubwayzNameHint) === city || norm(d.id) === city) {
      return d.countryCode;
    }
  }
  return null;
}

/**
 * Resolve Hubwayz location destinationId for Hotels-tab searchPhrase.
 * @returns {Promise<{ ok: boolean, destinationId?: number|string, countryCode?: string, error?: string, matchedName?: string }>}
 */
export async function resolveHubwayzDestinationFromSearchPhrase(
  searchPhrase = {},
  location = null
) {
  const directId = location?.hubwayzLocationId ?? searchPhrase?.hubwayzLocationId;
  if (directId == null || String(directId).trim() === "") {
    return {
      ok: false,
      error: "לא נמצא יעד. בחרו עיר מהרשימה.",
    };
  }

  const destinationType =
    location?.destinationType === "hotel" || searchPhrase?.destinationType === "hotel"
      ? "hotel"
      : "location";
  const countryCode =
    resolveCountryIso2FromSearchPhrase(searchPhrase, location) ||
    location?.countryCode ||
    location?.iso2 ||
    null;
  return {
    ok: true,
    destinationId: directId,
    destinationType,
    countryCode: countryCode ? String(countryCode).toUpperCase() : undefined,
    matchedName:
      location?.name ||
      location?.city ||
      location?.hubwayzNameHint ||
      searchPhrase?.city ||
      String(directId),
    source: "catalog_selection",
  };
}
